import {
    RESET_PASSWORD_OPEN_MODAL,
    RESET_PASSWORD_CLOSE_MODAL,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_RESULT,
} from 'Redux/actionTypes';

export const resetPasswordOpenModal = (data) => ({
    type: RESET_PASSWORD_OPEN_MODAL,
    payload: data
})

export const resetPasswordCloseModal = () => ({
    type: RESET_PASSWORD_CLOSE_MODAL
})

export const resetPasswordRequest = (data) => ({
    type: RESET_PASSWORD_REQUEST,
    payload: data
})

export const resetPasswordResult = (result) => ({
    type: RESET_PASSWORD_RESULT,
    payload: result
})